<template>
    <rb-loader v-model="localData.loading" :contained="true"></rb-loader>
    <div class="tab-content w-100 d-flex justify-space-between align-start">
        <div class="full-width-tab-content-text d-flex flex-column ga-8">
            <div class="config-group d-flex flex-column ga-3">
                <h2 class="title-medium">Quais perguntas o assistente vai fazer ao contato?</h2>
                <div class="d-flex flex-column ga-7">
                    <div class="d-flex justify-space-between align-center w-100">
                        <v-btn class="px-6 py-5 d-flex" style="width: fit-content !important;" prepend-icon="mdi-plus" variant="text"
                            color="primary-35" rounded="pill" hide-details @click="openPropertiesMenu" :loading="buttonLoading">
                            Adicionar propriedade
                            <SelectMenu titulo="Adicionar propriedade" v-model="menuOpen" :data="localData.properties"
                                v-model:selected="localData.selectedProperties" />
                        </v-btn>
                        <rb-input class="search-input" width="240px" prepend-inner-icon="mdi-magnify"
                            v-model="search" placeholder="Pesquisar" clearable></rb-input>
                    </div>
                    <v-list>
                        <div v-for="item in filteredProperties" :key="getPropertyKey(item)">
                            <v-list-item class="property-item text-left pa-2">
                                <v-list-item-title>
                                    {{ item.name }}
                                </v-list-item-title>
                                <v-btn class="px-6 py-5 d-flex" @click="removeProperty(item)" icon="mdi-trash-can-outline" variant="text" size="small"></v-btn>
                            </v-list-item>
                            <v-divider class="w-100"></v-divider>
                        </div>
                    </v-list>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, defineProps, defineEmits, ref } from 'vue';
import { fetchProperties, setDefaultProperties } from '@/ai_studio/utils/fetchData';
import SelectMenu from '@/assistents/components/SelectMenu.vue';
import RbLoader from '@/ai_studio/components/common/RbLoader.vue';
const emit = defineEmits(['update:modelValue']);
const menuOpen = ref(false);
const search = ref('');
const buttonLoading = ref(false);

const props = defineProps({
    modelValue: { type: Object, required: true }
})

const localData = computed({
    get: () => props.modelValue,
    set: (newValue) => {
        emit('update:modelValue', newValue);
    }
});

const openPropertiesMenu = async () => {
    if (localData.value.properties.length) {
        menuOpen.value = true;
        return;
    }
    
    buttonLoading.value = true;
    try {
        const response = await fetchProperties();
        localData.value.properties = [...response];
    } catch (error) {
        console.error(error);
        const defaultProperties = setDefaultProperties();
        localData.value.properties =  [...defaultProperties];
    } finally {
        buttonLoading.value = false;
        menuOpen.value = true;
    }
}

const getPropertyKey = (property) => property?.id ?? property?.coluna ?? property?.nome;

const removeProperty = (property) => {
    const properties = [...localData.value.selectedProperties];
    const propertyKey = getPropertyKey(property);
    const index = properties.findIndex(item => item === property || (propertyKey && getPropertyKey(item) === propertyKey));
    if (index === -1) return;

    properties.splice(index, 1);
    localData.value = {
        ...localData.value,
        selectedProperties: properties
    };
}

const filteredProperties = computed(() => {
    if (!search.value) {
        return localData.value.selectedProperties
    }
    return localData.value.selectedProperties.filter(item => item.name.toLowerCase().includes(search.value.toLowerCase()))
})

</script>

<style lang="scss" scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss';

.property-item {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    color: #0E1211;
}

.property-item:deep(.v-list-item__content) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.search-input:deep(.v-input__details) {
    display: none !important;
}

.search-input:deep(.v-input__control) {
    width: 240px !important;
    margin-left: auto;
}
</style>
